import {Piechart} from './variant/piechart';

export const AverageHint = {
	Piechart,
};
